import './he-is-coming-homepage.css';
import { NavElement } from './menu/nav-element';

const HeIsComingHomepage: React.FC = () => (
    <div className='he-is-coming-homepage'>
        <div className='he-is-coming-homepage-title'>
            <a href="https://store.steampowered.com/app/2824490/He_is_Coming" className='he-is-coming-steam-link' target="_blank" rel="noreferrer">
                <img src="/resources/menu/he_is_coming_title_halloween.png" alt="He Is Coming Logo" />
            </a>
        </div>

        <div className='he-is-coming-homepage-content'>
            <div className='he-is-coming-navigation'>
                <NavElement
                    image="/resources/menu/menu_icon_cauldron.png"
                    to="/heiscoming/cauldron"
                >
                    <span>Cauldron</span>
                </NavElement>
                <NavElement
                    image="/resources/cauldron/cauldron_icon.png"
                    to="/heiscoming/cauldron#cauldron"
                    indent={1}
                >
                    <span>Cooking</span>
                </NavElement>
                <NavElement
                    image="/resources/cauldron/ingredients_table_icon.png"
                    to="/heiscoming/cauldron#ingredientsTable"
                    indent={1}
                >
                    <span>Ingredients Table</span>
                </NavElement>
                <NavElement
                    image="/resources/menu/menu_icon_compendium.png"
                    to="/heiscoming/compendium"
                >
                    <span>Compendium</span>
                </NavElement>
                <NavElement
                    image="/resources/compendium/item_sets_icon.png"
                    to="/heiscoming/compendium#itemSets"
                    indent={1}
                >
                    <span>Item Sets</span>
                </NavElement>
                <NavElement
                    image="/resources/compendium/potion_seller_icon.png"
                    to="/heiscoming/compendium#potions"
                    indent={1}
                >
                    <span>Potions</span>
                </NavElement>
                <NavElement
                    image="/resources/compendium/egg_icon.png"
                    to="/heiscoming/compendium#eggs"
                    indent={1}
                >
                    <span>Eggs</span>
                </NavElement>
            </div>
        </div>
    </div >
);
export default HeIsComingHomepage;